export default "__VITE_ASSET__Ce1ivzi5__"